<template>
  <section>

    <b-card class="mb-2">
      <b-card-body>
        <b-row class="font-weight-bold">
          <b-col cols="1">Resim</b-col>
          <b-col cols="4">Trendyol Ürün</b-col>
          <b-col cols="7">Detay</b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <TrendyolProductItem v-for="product in _products" :key="product.id" :product="product"/>
  </section>
</template>
<script>
import {mapGetters} from "vuex";
import TrendyolProductItem from "@/views/v2/trendyol/product/TrendyolProductItem.vue";

export default {
  name: 'TrendyolProductItems',
  components: {TrendyolProductItem},
  computed: {
    ...mapGetters('tyProductV2', ['_products'])
  }
}
</script>